import { Container, Box, Stack } from "@mui/material";
// import SearchHospital from "../components/SearchHospital/SearchHospital";
// import FAQs from "../components/Sections/FAQs/FAQs";
// import OurFamilies from "../components/Sections/OurFamilies/OurFamilies";
// import Blogs from "../components/Sections/Blogs/Blogs";
// import PatientCaring from "../components/Sections/PatientCaring/PatientCaring";
// import Specialists from "../components/Sections/Specialists/Specialists";
 import { Specialization } from "../components/Specialization";
// import Offers from "../components/Sections/Offers/Offers";
import Navbar from "../components/Navbar";
import HeroSlider from "../components/HeroSlider";
import SearchHospital from "../components/SearchHospital";
import { HeroServices } from "../components/HeroServices";
import { Offers } from "../components/Offers";
import { Specialists } from "../components/Specialists";
import PatientCaring from "../components/PatientCaring";
import News from "../components/News";
import OurFamilies from "../components/OurFamilies";
import FAQs from "../components/FAQ";
// import HeroServices from "../components/IconLayout/HeroServices";

export default function Home() {
  return (
    <Box>
      <Box
        sx={{
          background:
            "linear-gradient(#E7F0FF , rgba(232, 241, 255, 0.47) 90%, #fff 10%)",
        }}
        mb={4}
      >
        <Navbar/>
        
        <Container maxWidth="xl">
          <HeroSlider/>
          <Stack
            p={{ xs: 2.5, md: 8 }}
            mt={{ xs: -2, md: 0, lg: -6, xl: -10 }}
            position="relative"
            zIndex={99}
            bgcolor="#fff"
            borderRadius="15px"
            spacing={10}
            boxShadow="0 0 12px rgba(0,0,0,0.1)"
          >
            <SearchHospital/>
            <HeroServices/>
          </Stack>
        </Container>
      </Box>

      <Offers/>

      <Specialization/>

      <Specialists/>

      <PatientCaring />

      < News />

      <OurFamilies />

      <FAQs />
    </Box>
  );
}
